'use client'

import React from 'react'
import Image from 'next/image'
import { CheckCircleIcon } from '@heroicons/react/20/solid'
import { TightLogoCloud } from '@/components/LogoCloud'
import danAvatar from '../images/authors/DanCorcoran.jpeg'

type LeadSellProps = {
  titleText: string
  shinyTitleText?: string
  includeBenefits?: boolean
  titleTextSize?: string
}

function Benefit({ text }: { text: string }) {
  return (
    <div className="text-md my-1 flex items-center gap-x-2 text-slate-400">
      <CheckCircleIcon className="h-4" />
      {text}
    </div>
  )
}

export function LeadSell({
  titleText,
  shinyTitleText,
  includeBenefits = true,
  titleTextSize = 'text-2xl',
}: LeadSellProps) {
  return (
    <div className="flex max-w-[36rem] items-center justify-center">
      <div>
        <h2
          className={`mb-6 ${titleTextSize} font-bold tracking-tight text-slate-200`}
        >
          {titleText}{' '}
          {shinyTitleText && (
            <span className="text-extrabold bg-gradient-to-r from-indigo-300 via-sky-400 to-indigo-200 bg-clip-text text-white text-opacity-0">
              {shinyTitleText}
            </span>
          )}
        </h2>
        {includeBenefits && (
          <div className="mb-6">
            <Benefit text="Easily explore and monitor Snowflake usage" />
            <Benefit text="Automatically lower costs by 10-30% with the click of a button" />
            <Benefit text="Allocate usage to teams, departments, projects" />
          </div>
        )}
        <div className="border-l-2 border-white py-2 pl-4 text-lg text-white">
          <div className="flex gap-x-2">
            SELECT is a team favorite - its cost monitoring and auto savings
            give us peace of mind that our Snowflake spend is in check.
          </div>
          <div className="relative mt-6 flex items-center justify-between">
            <div className="flex items-center gap-x-4">
              <div className="h-12 overflow-hidden rounded-full bg-slate-50">
                <Image
                  className="h-12 w-12 object-cover"
                  src={danAvatar}
                  unoptimized
                  alt=""
                  width={56}
                  height={56}
                />
              </div>
              <div>
                <div className="font-display text-md text-white">
                  Dan Corcoran
                </div>
                <div className="mt-1 text-sm font-semibold text-sky-400">
                  Senior Data Engineering Manager
                </div>
                <div className="font-display mt-1 text-sm text-white">
                  Gopuff
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-md mb-3 mt-10 text-slate-400">
          Trusted by the best, and hundreds more.
        </div>
        <TightLogoCloud />
      </div>
    </div>
  )
}